import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import classnames from 'classnames';
import { isAfter, isSameDay } from '../utils/date-fns';
export default function useRangeCls(_ref) {
  var prefixCls = _ref.prefixCls,
    isRange = _ref.isRange,
    rangeValue = _ref.rangeValue,
    hoverRangedValue = _ref.hoverRangedValue,
    isCurrentMonth = _ref.isCurrentMonth,
    isAfterStart = _ref.isAfterStart,
    isBeforeEnd = _ref.isBeforeEnd,
    isStart = _ref.isStart,
    isEnd = _ref.isEnd;
  function getClassName(date) {
    if (isRange) {
      var _classnames;
      var _rangeValue = rangeValue || [null, null];
      if (hoverRangedValue === null || hoverRangedValue === void 0 ? void 0 : _findInstanceProperty(hoverRangedValue).call(hoverRangedValue, function (n) {
        return n;
      })) {
        _rangeValue = hoverRangedValue;
      }
      if (_filterInstanceProperty(_rangeValue).call(_rangeValue, function (n) {
        return n;
      }).length !== _rangeValue.length) return {};
      if (isSameDay(_rangeValue[0], _rangeValue[1])) return {};
      if (isCurrentMonth && !isCurrentMonth(date)) return {};
      if (_rangeValue[0] && _rangeValue[1] && isAfter(_rangeValue[0], _rangeValue[1])) return {};
      return classnames((_classnames = {}, _defineProperty(_classnames, "".concat(prefixCls, "-range-view"), isAfterStart(date, _rangeValue) && isBeforeEnd(date, _rangeValue)), _defineProperty(_classnames, "".concat(prefixCls, "-range-start"), isStart(date, _rangeValue)), _defineProperty(_classnames, "".concat(prefixCls, "-range-end"), isEnd(date, _rangeValue)), _classnames));
    }
    return {};
  }
  return getClassName;
}